const LANDING_BASE_URL =
  import.meta.env.VITE_LANDING_URL ?? 'http://localhost:3002';

/**
 * URL to the privacy policy on the landing site (e.g. /en/privacy or /es/privacy).
 * Use the portal's current locale so the policy opens in the user's language.
 */
export function getLandingPrivacyUrl(locale: string): string {
  const normalized = locale?.startsWith('es') ? 'es' : 'en';
  return `${LANDING_BASE_URL.replace(/\/$/, '')}/${normalized}/privacy`;
}
